<template>
  <div class="bg">
    <div class="bigTitle">
      <span class="redHighLight">Focus Groups</span> are recommended when...
    </div>
    <div class="IDIBox">
      <div class="IDI_box">
        <div class="text">Consensus or debate is required to</br>explore disparate views</div>
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/qualitative/FocusGroup/FG_box_1.png" alt="">

      </div>
      <div class="IDI_box">
        <div class="text">The interaction between the</br>participants will likely spark a</br>discussionthat illuminates a</br>topic and draws-out latent issues</div>
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/qualitative/FocusGroup/FG_box_3.png" alt="">
      </div>
      <div class="IDI_box">
        <div class="text">We want to generate opportunities</br>for pointt-counterpoint discussion</br>and resolution</div>
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/qualitative/FocusGroup/FG_box_2.png" alt="">

      </div>
      <div class="IDI_box">
        <div class="text">It is necessary to explore common trends</div>
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/qualitative/FocusGroup/FG_box_4.png" alt="">

      </div>
    </div>
    <div class="mid">
      <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/qualitative/FocusGroup/FG_eGroup_back.png" alt="">
      <div class="text">

        <div>Our online-based <span class="highLight">eGroup</span> tool helps you to speed up the fieldWork time,</br>reduce travelling costs,and keep to the research scope.</div>
      </div>
    </div>
    <div class="photo">
      <div class="photo_box_1">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/qualitative/FocusGroup/Artboard 19.png" alt="">
      </div>

      <div class="photo_box_3">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/qualitative/FocusGroup/Artboard 18.png" alt="">
      </div>
      <div class="photo_box_2">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/qualitative/FocusGroup/Artboard 17.png" alt="">
      </div>
    </div>
    <div class="bottom">
<div class="title">Research Consultants</div>
<div class="value">
  Meet <span class="highLight">our consultants</span> who can give you to the most relevant & local advice in carrying</br>out your research study
</div>

    </div>

    <case-study />

  </div>
</template>

<script>
import CaseStudy from "@/components/caseStudy";
import { advertisementFlow } from "@/api/api";

export default {
  data() {
    return {};
  },
  created() {
    this.loading();
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.webinercookies();
  },
  components: {
    CaseStudy
  },
  methods: {
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      }
    },
    toguid(path, id) {
      var Id = id;
      localStorage.setItem("toId", Id);
      this.$router.push({ path });
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "focus",
          source: "",
          information: "Solutions_focus"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "focus",
          source: this.$route.query.source,
          information: "Solutions_focus"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
    contact() {
      let routeData = this.$router.resolve({ path: "/contact?source=bid" });
      window.open(routeData.href, "_blank");
    },
    loading() {
      this.$loading({
        lock: true,
        background: "rgba(255, 255, 255,1)"
      });
      setTimeout(() => {
        this.$loading().close();
      }, 700);
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  font-family: "Nunito";
}
.bg {
  background-image: url(https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/Background.png);
  background-size: cover;
}
.redHighLight {
  color: #e73323;
}
.blueHighLight {
  color: #4c8fd5;
}
.bigTitle {
  font-size: 60px;
  font-weight: 700;
  text-align: center;
  padding-top: 120px;
  padding-bottom: 50px;
  color: #1e364e;
}
.IDIBox {
  padding: 0 150px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .IDI_box {
    width: 49%;
    margin-bottom: 15px;
    position: relative;
    img {
      width: 100%;
    }
    .text {
      position: absolute;
      width: 100%;
      height: 100%;
      text-align: center;
      display: flex;
      font-size: 18px;
      justify-content: center;
      align-items: center;
      color: #1e364e;
    }
  }
}
.mid {
  position: relative;
  img {
    width: 100%;
  }
  .text {
    text-align: center;
    position: absolute;
    top: 35%;
    font-size: 22px;
    color: #fff;
    display: flex;
    width: 100%;
    justify-content: center;
    .highLight {
      text-decoration: underline;
      color: #e73323;
    }
  }
}
.photo {
  position: relative;
  height: 530px;
  overflow: hidden;
  .photo_box_1,
  .photo_box_2,
  .photo_box_3 {
    position: absolute;
    margin-top: 50px;
    width: 35%;
    // height: 202.5px;
    background-color: #fff;
    img {
      width: 100%;
      border: 10px solid #fff;
    }
  }
  .photo_box_1 {
    transform: rotate(-10deg);
    top: 20%;
  }
  .photo_box_2 {
    transform: rotate(10deg);
    left: 33%;
  }
  .photo_box_3 {
    transform: rotate(-10deg);
    left: 66%;
    top: 20%;
  }
}
.bottom{
  text-align: center;
      color: #1e364e;
      margin-bottom: 80px;
  .title{
    font-size: 40px;
    font-weight: 700;
margin-bottom: 50px;
  }
  .value{
    font-size: 22px;
     .highLight{
    color: #e73323;
    text-decoration: underline;
    font-weight: 700;
    font-size: 30px;
  }
  }
}
</style>